import { useIntercom } from 'react-use-intercom';
import { LifebuoyIcon } from '@heroicons/react/24/outline';

// Small tab pinned against the bottom-right edge of the viewport. Replaces
// the default Intercom bubble (hidden at boot) with something less
// intrusive; clicking opens the messenger programmatically.
export function HelpLauncher() {
  const { show } = useIntercom();

  return (
    <button
      type={ `button` }
      onClick={ () => show() }
      className={ `fixed bottom-4 right-0 z-30 flex flex-col items-center rounded-l-md bg-[#81CCC5] px-1.5 py-2 text-xs font-medium text-gray-800 shadow-sm hover:brightness-95` }
    >
      <LifebuoyIcon
        className={ `mb-1 h-4 w-4 text-gray-700` }
        aria-hidden={ `true` }
      />
      <span className={ `tracking-wide [writing-mode:vertical-rl]` }>
        { `Help` }
      </span>
    </button>
  );
}
